import React, { useState, useEffect, useCallback } from 'react';
/* import ReactLoading from 'react-loading'; */
import { getEvent, deleteEventWholeData, getEventCisDataByEventDate, } from '../../helper/helper';
import './EventCis.scss';
import EventModal from './EventModal';
// import UploadCISModal from './UploadCISModal';
import CISViewModal from './CISViewModal';
import EventTile from './EventTile';
import CustomButton from '../../components/ui/Button/Button';
import DataUnavailableMessage from '../../components/ui/DataUnavailableMessage';
import Loader from '../../components/Loader/Loader';
import MonthSelector from '../../components/ui/MonthSelector';
import DeleteConfirmationModal from '../../components/ui/Modal/deleteConfirmationModal';
import ModalWrapper from '../../components/ui/ModalWrapper/ModalWrapper';
import Home from '../CisUpload/CisUpload';

const EventCis = () => {
  // const username = localStorage.getItem('username');
  // const [userDetail, setUserDetail] = useState(null);
  const [eventApiData, setEventApiData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const currentDate = new Date();
  const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
  const lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
  const firstDayOfMonthString = firstDayOfMonth.toISOString().split('T')[0];
  const lastDayOfMonthString = lastDayOfMonth.toISOString().split('T')[0];
  const [startDate, setStartDate] = useState(firstDayOfMonthString);
  const [endDate, setEndDate] = useState(lastDayOfMonthString);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalIsOpen1, setModalIsOpen1] = useState(false);
  const [modalIsOpen2, setModalIsOpen2] = useState(false);
  const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);
  const [eventinfoforCis, setEventinfoforCis] = useState({});
  const [cisdata, setCisdata] = useState([]);
  const [deleteInfo, setDeleteInfo] = useState({ id: null, name: '' });
  const user = JSON.parse(localStorage.getItem('user_data'));

  // useEffect(() => {
  //   async function fetchUser() {
  //     let { data } = await getUser({ username: username });
  //     setUserDetail(data);
  //   }

  //   fetchUser();
  // }, [username]);

  useEffect(() => {
    async function fetchEventCisData() {
      try {
        let { data } = await getEventCisDataByEventDate({ startDate, endDate });
        const groupedData = data.reduce((acc, item) => {
          const key = `${item.eventName} ${item.eventDate}`;
          if (!acc[key]) {
            acc[key] = [];
          }
          acc[key].push(item);
          return acc;
        }, {});
        setCisdata(groupedData);
      } catch (error) {}
    }

    fetchEventCisData();
  }, [startDate, endDate]);

  const fetchEvents = useCallback(async () => {
    setIsLoading(true);
    try {
      const payload = {
        startDate,
        endDate,
        userID: user?._id,
      };
      let { data } = await getEvent(payload);
      //console.log(data);

      setEventApiData(data);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  }, [startDate, endDate, user?._id]);

  useEffect(() => {
    if (user?._id) {
      fetchEvents();
    }
  }, [startDate, endDate, fetchEvents, user?._id]);

  const handleUpload = (id, name, date) => {
    setEventinfoforCis({ id,name, date });
    openModal1();
  };

  const handleView = (id, date) => {
    setEventinfoforCis({ id, date });
    openModal2();
  };

  const handleDelete = (id, name) => {
    setDeleteInfo({ id, name });
    setDeleteModalIsOpen(true);
  };

  const confirmDelete = async () => {
    const { id, name } = deleteInfo;
    let data = await deleteEventWholeData({ id, name });
    if (data) {
      fetchEvents();
    }
    setDeleteModalIsOpen(false);
  };

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };
  const openModal1 = () => {
    setModalIsOpen1(true);
  };

  const closeModal1 = () => {
    setModalIsOpen1(false);
  };
  const openModal2 = () => {
    setModalIsOpen2(true);
  };

  const closeModal2 = () => {
    setModalIsOpen2(false);
  };

  const handleMonthChange = ({ startDate, endDate }) => {
    setStartDate(startDate);
    setEndDate(endDate);
  };

  return (
    <div className="ec-main">
      <div className="ec-container">
        <div className="ec-block-container">
          <div className="filter-menu-list">
            <div className="filter-menu">
              <div className="filter-datemenu">
                <MonthSelector onMonthChange={handleMonthChange} />
              </div>
            </div>
            {/* <CustomButton disabled={isLoading} buttonType="search" onClick={fetchEvents} /> */}
            <div className="upload-button-container">
              {user?.role !== 'employee' && (
                <>
                  <EventModal
                    modalIsOpen={modalIsOpen}
                    closeModal={closeModal}
                    refetch={fetchEvents}
                  />
                  <CustomButton disabled={isLoading} btnLabel="Add Event" onClick={openModal} />
                </>
              )}
            </div>
          </div>
          {/* <UploadCISModal
            modalIsOpen={modalIsOpen1}
            closeModal={closeModal1}
            eventinfoforCis={eventinfoforCis}
          /> */}
          <ModalWrapper open={modalIsOpen1} onClose={closeModal1}>
            <Home eventinfoforCis={eventinfoforCis}/>
          </ModalWrapper>
          <CISViewModal
            modalIsOpen={modalIsOpen2}
            closeModal={closeModal2}
            eventinfoforCis={eventinfoforCis}
            cisdata={cisdata}
          />
          <DeleteConfirmationModal
            isOpen={deleteModalIsOpen}
            onClose={() => setDeleteModalIsOpen(false)}
            onDelete={confirmDelete}
            message={`Are you sure you want to delete <b>${deleteInfo.name.toUpperCase()}</b> and CIS Details?`}
          />
          <div className="eventlist-container">
            {isLoading ? (
              <Loader />
            ) : (
              <>
                {eventApiData?.length > 0 ? (
                  <>
                    {eventApiData.map((event) => (
                      <EventTile
                        key={event._id}
                        event={event}
                        onUpload={handleUpload}
                        onView={handleView}
                        onDelete={handleDelete}
                        userRole={user?.role}
                      />
                    ))}
                  </>
                ) : (
                  <DataUnavailableMessage selectedMonth={startDate} />
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default EventCis;
